export const SUPPORTED_LANGUAGES = ["en", "zh-CN", "ja", "ko", "es"] as const;
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

export function normalizeLanguage(value: string | null | undefined): SupportedLanguage {
  const language = String(value ?? "").trim().replaceAll("_", "-").toLowerCase();
  if (language === "zh" || language.startsWith("zh-")) return "zh-CN";
  if (language === "ja" || language.startsWith("ja-")) return "ja";
  if (language === "ko" || language.startsWith("ko-")) return "ko";
  if (language === "es" || language.startsWith("es-")) return "es";
  if (language === "en" || language.startsWith("en-")) return "en";
  return "en";
}

export function chooseSupportedLanguage(languages: readonly string[]): SupportedLanguage {
  for (const language of languages) {
    const normalized = normalizeLanguage(language);
    if (normalized !== "en" || language.toLowerCase().startsWith("en")) return normalized;
  }
  return "en";
}
